import type {
    BoardMoveCheck,
    BoardMoveVerdict,
    BoardPlacement,
} from "./Board.types";
import { getCellKey } from "./boardCells";

/** Cells that refuse the dragged copy, by cell key, with the reason. */
export type BoardRefusals = ReadonlyMap<string, string>;

export const NO_REFUSALS: BoardRefusals = new Map();

interface GetBoardRefusalsArgs<TItem> {
    item: TItem;
    from: BoardPlacement;
    placements: readonly BoardPlacement[];
    canMove?: (check: BoardMoveCheck<TItem>) => BoardMoveVerdict;
}

/**
 * Asks `canMove` once per cell when a drag starts, so hovering never calls
 * it. The card's own cell always accepts it back.
 */
export const getBoardRefusals = <TItem>({
    item,
    from,
    placements,
    canMove,
}: GetBoardRefusalsArgs<TItem>): BoardRefusals => {
    if (canMove === undefined) {
        return NO_REFUSALS;
    }
    const fromKey = getCellKey(from);
    const refusals = new Map<string, string>();
    placements.forEach((to) => {
        const cellKey = getCellKey(to);
        const verdict =
            cellKey === fromKey ? null : canMove({ item, from, to });
        if (verdict !== null && !verdict.isAllowed) {
            refusals.set(cellKey, verdict.reason);
        }
    });
    return refusals;
};
